import { useContext } from "react"
import { UserContext } from "../context/userContext"
import { LoaderMedium } from "./Loaders"
import { gql, useQuery } from "@apollo/client"

import styles from "../styles/AllParticipantsSummary.module.css"

export default function AllParticipantsSummary() {
  const user = useContext(UserContext)

  const GET_PARTICIPANTS_STAT = gql`
    query myParticipantsStats($staff_id: ID!, $organization_id: ID!) {
      myParticipantsStats(
        staff_id: $staff_id
        organization_id: $organization_id
        type: "all_participants"
      ) {
        currently_assigned
        currently_unassigned
        engaged
        unengaged
        kiosk
        referrals
        discharged
      }
    }
  `

  const { data, loading, error } = useQuery(GET_PARTICIPANTS_STAT, {
    variables: {
      staff_id: user?.staff_id,
      organization_id: user?.organization_id,
    },
    fetchPolicy: "network-only",
    skip: !user,
  })
  if (loading) {
    return (
      <div className={styles.card}>
        <LoaderMedium />
      </div>
    )
  }
  if (error) {
    return <p>Error loading participant stats: {error.message}</p>
  }

  const stats = data?.myParticipantsStats
  const renderCount = (count) => count ?? 0

  const calculateTotalParticipants = () =>
    renderCount(stats?.currently_unassigned) +
    renderCount(stats?.engaged) +
    renderCount(stats?.unengaged) +
    renderCount(stats?.kiosk) +
    renderCount(stats?.referrals) +
    renderCount(stats?.discharged)

  const rows = [
    { label: "Total Participants", value: calculateTotalParticipants() },
    { label: "Unassigned", value: renderCount(stats?.currently_unassigned) },
    { label: "Engaged", value: renderCount(stats?.engaged) },
    { label: "Unengaged", value: renderCount(stats?.unengaged) },
    { label: "Kiosk", value: renderCount(stats?.kiosk) },
    { label: "Referrals", value: renderCount(stats?.referrals) },
    { label: "Discharged", value: renderCount(stats?.discharged) },
  ]

  return (
    <section className={styles.card}>
      <div className={styles.headerRow}>
        <h3 className="sidebar-section-title">All Participants</h3>
      </div>

      <div className={styles.body}>
        {rows.map((row) => (
          <div key={row.label} className={styles.infoLine}>
            <span className={styles.lineLabel}>{row.label}</span>
            <span className={styles.countPill}>{row.value}</span>
          </div>
        ))}
      </div>
    </section>
  )
}
